import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormWidgetAvvComponent } from '@modules/bcm/@work-flows/@form-widgets/core/avv/form-widget-avv.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    declarations: [FormWidgetAvvComponent],
    imports: [
        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatCheckboxModule,

        SignaturePadModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatInputModule
    ],
    exports: [FormWidgetAvvComponent]
})
export class FormWidgetAvvModule {
    
}
